module.exports = __webpack_public_path__ + "static/media/WorkSans_Bold.d532a087.woff2";